<template>
  <div class="info">
    <div class="mask" @click="maskClick"></div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in info" :key="index">
        <div class="list">
          <img class="icon" :src="item.src" alt />
          <div class="title">{{ item.title }}</div>
          <div class="glodsync">
            <img src="@/assets/glodsync.png" alt />
          </div>
          <div class="list_item" v-for="(item1, i) in item.list" :key="i">
            {{ item1 }}
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="btn" @click="openVip">{{ btnName }}</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "right",
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    }
  },
  data () {
    return {
      swiperOption: {
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination"
        },
        loop: false,
        speed: 400,
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: true,
        preventLinksPropagation: true,
        slideToClickedSlide: true,
        notNextTick: true,
        observer: true,
        observeParents: true
      },
      btnName: "立即购买",
      info: []
    };
  },
  activated () {
    console.log('activated:', this.$route.params);
    document.title = "特权介绍";
    this.info = this.globalData.info;
    this.btnName = this.globalData.isVip ? "立即续费" : "立即购买";
    setTimeout(() => {
      this.swiper.slideTo(this.$route.params.showIndex);
    });
  },
  methods: {
    openVip () {
      this.$router.replace({ name: "Vip", params: { openVip: true } });
      // this.$emit("submitPay", true);
    },
    maskClick (e) {
      this.$router.back();
    }
  }
};
</script>

<style lang="less" scoped src="../styles/right.less">
</style>

<style lang="less">
.swiper-pagination-bullet {
  background: #fff !important;
  opacity: 0.3;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  border-radius: 5px !important;
  width: 28px !important;
  transition: all 0.1s;
}
</style>